import {MDBIcon} from "mdb-react-ui-kit";
import { Card } from "react-bootstrap";

function ModelManager(){
    return(
        <>

        <div className="max-width-set top-title-3">
        <div className='px-5 mx-5'>
            <h1 className='top-title-0 text-center py-1'>3D Manager</h1>

            <p className="top-title-2 text-center  modelmanger-text">
            Organize - Control - Deliver
            </p>
        </div>
        <div className="player-feature max-width-set">
            <p className=' mx-5 themeColor text-center fw-bold '> <br />Your solution for efficient 3D content management, our 3D Manager offers seamless organization, user control, and content delivery. With a unified platform and comprehensive toolset, we empower you to optimize your 3D assets.</p>
          <div className="feature-list-dropdown">
          <ul>
            <li>
              <p className="discovery-list">
                <b>Content Management:</b> Centralized management of 3D models and players.
              </p>
            </li>
            <li>
              <p className="discovery-list">
                <b>User Permissions:</b> Tools for assigning and managing user permissions to control access to 3D content.
              </p>
            </li>
            <li>
              <p className="discovery-list">
                <b>Master Repository:</b> A repository for storing and organizing 3D assets, making it easy to find and utilize them.
              </p>
            </li>
            <li>
              <p className="discovery-list">
                <b>Branded 3D Libraries:</b> Creation of customized 3D libraries with branding options for specific user groups or purposes.
              </p>
            </li>
            <li>
              <p className="discovery-list">
                <b>Delivery Platform:</b> A platform for delivering and embedding 3D experiences on designated web pages.
              </p>
            </li>
          </ul>
          </div>
          </div>

          <br />
          <div className=" d-flex justify-content-center align-content-center  max-width-set my-2">
            <div className=" d-flex justify-content-center align-content-center  video-player-modelLibrary">
              <div className="info-img-modelLibrary">
                <div className=' d-flex justify-content-center' >
				          <Card className="bg-transparent shadow-0 border-0 text-white">
                    <Card.Img src="Image/paracosma-gtie-modal-manager.jpg" alt="Card image" className="container p-0 m-0" />
                    <Card.ImgOverlay className="p-0 m-0">
                      <video className='container p-0' loop={true} autoPlay preload='auto' muted playsInline>
                        <source src="video/paracosma-gtie-modal-manager.mp4" type="video/mp4" />
                      </video>
                    </Card.ImgOverlay>
                  </Card>
                </div>
              </div>
            </div>
          </div>

        </div>
        <br />
        
        </>
    )
}

export default ModelManager;